<template>
    <a :href="urlWishList" rel="nofollow" :aria-label="$translate('Ceres::Template.wishList')">
        <span class="badge-right">{{ wishListCount }}</span>
        <i aria-hidden="true" class="fa fa-heart-o"></i>
    </a>
</template>

<script>
export default {
    computed:
    {
        wishListCount()
        {
            return this.$store.getters.wishListCount;
        },

        urlWishList()
        {
            return App.urls.wishList;
        }
    }
}
</script>
